// extracted by mini-css-extract-plugin
export default {"participants":"Participants_participants__f7ZuB","grid-view":"Participants_grid-view__OBsvF"};